import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=4b3c0f32&functional=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b3c0f32')) {
      api.createRecord('4b3c0f32', component.options)
    } else {
      api.rerender('4b3c0f32', component.options)
    }
    module.hot.accept("./TheFooter.vue?vue&type=template&id=4b3c0f32&functional=true", function () {
      api.rerender('4b3c0f32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/TheFooter.vue"
export default component.exports